import { CRUDFactory } from '../../core/CRUDFactory';

export default class IoTNodeService extends CRUDFactory {
  constructor() {
    super({
      EndPoint: 'IoTNode'
    });
  }
  ADAPTER_IN(entity: any) {
    ///start:generated:adapterin<<<
    entity.ConvertedCreatedAt = this.toJavascriptDate(entity.CreatedAt);
    ///end:generated:adapterin<<<

    return entity;
  }

  ADAPTER_OUT(entity: any) {
    ///start:generated:adapterout<<<
    entity.CreatedAt = this.toServerDate(entity.ConvertedCreatedAt);
    ///end:generated:adapterout<<<
  }
}
